import * as FileSaver from 'file-saver';
import { HttpResponse } from '@angular/common/http';

export class FileService {
	static saveFile(fileContents: any, fileName: string): void {
		FileSaver.saveAs(fileContents, fileName);
	}

	static getFileName(fileName: string, response: HttpResponse<any>): string {
		return response.headers.get('file-ext') ?
				fileName + response.headers.get('file-ext').toString()
			:	fileName;
	}

	static getFile(response: HttpResponse<Blob>): Blob {
		const fileExtension = FileService.getMimeType(response.headers.get('content-type'));

		return new Blob([response.body], {type: fileExtension});
	}

	static getMimeType(mimeType: string): string {
		let extension: string;
		switch(mimeType) {
			case 'application/msword':
			case 'application/x-tika-msoffice':
				extension = 'application/msword';
				break;
			case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
			case 'application/x-tika-ooxml':
				extension = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
				break;
			default:
				extension = mimeType;
		}

		return extension;
	}
}
